"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _State = _interopRequireDefault(require("../State"));

// Libraries
// Components
var callIfDefined = function callIfDefined(handler) {
  return handler && handler();
};

var Toggle = function Toggle(_ref) {
  var defaultIsOpen = _ref.defaultIsOpen,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      children = _ref.children;
  return _react["default"].createElement(_State["default"], {
    initial: {
      isOpen: defaultIsOpen
    }
  }, function (_ref2) {
    var isOpen = _ref2.isOpen,
        setState = _ref2.setState;
    return children({
      isOpen: isOpen,
      handleOpen: function handleOpen() {
        return setState({
          isOpen: true
        }, function () {
          return callIfDefined(onOpen);
        });
      },
      handleClose: function handleClose() {
        return setState({
          isOpen: false
        }, function () {
          return callIfDefined(onClose);
        });
      },
      handleToggle: function handleToggle() {
        return setState({
          isOpen: !isOpen
        }, function () {
          isOpen ? callIfDefined(onClose) : callIfDefined(onOpen);
        });
      }
    });
  });
}; // --------------------------------------------------
// PropTypes
// --------------------------------------------------


Toggle.propTypes = {
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  defaultIsOpen: _propTypes["default"].bool
};
Toggle.defaultProps = {
  onOpen: null,
  onClose: null,
  defaultIsOpen: false
};
var _default = Toggle;
exports["default"] = _default;